import React, { useRef, useState } from 'react';
import { Box, Skeleton, Stack } from '@compass/core';
import { Alert } from '@mui/material';
import { SchoolEnrollmentDataProvider, useSchoolEnrollmentData } from '../contexts/SchoolEnrollmentDataContext';
import { SchoolEnrollmentFilterControls } from './SchoolEnrollmentFilterControls';
import { SchoolEnrollmentChart } from './SchoolEnrollmentChart';
import { DashboardCard, DashboardCardContext } from '../components/DashboardCard';
import { Chart } from 'devextreme-react/chart';
import { useContext } from 'react';
import { DashboardChartViewSelect } from '../components/DashboardChartViewSelect';
import { DASHBOARD_CHART_VIEW_CONFIG, DashboardChartView } from '../types';

const SchoolEnrollmentCardContent = () => {
    const { data, loading, error, filter } = useSchoolEnrollmentData();
    const { isExpanded } = useContext(DashboardCardContext);
    const chartRef = useRef<Chart>(null);
    const [chartView, setChartView] = useState<DashboardChartView>(DASHBOARD_CHART_VIEW_CONFIG.schoolEnrollment.recommendedView);

    const handleExport = () => {
        if (chartRef.current) {
            const yearLabel = filter.schoolYear || 'CurrentYear';
            chartRef.current.instance.exportTo(`SchoolEnrollment_${yearLabel}`, 'png');
        }
    };

    if (loading) {
        return (
            <DashboardCard title="Schools with Highest Enrollments">
                <Box sx={{ p: 2 }}>
                    <Stack spacing="md">
                        <Skeleton variant="rounded" height={40} />
                        <Skeleton variant="rounded" height={300} />
                    </Stack>
                </Box>
            </DashboardCard>
        );
    }

    if (error) {
        return (
            <DashboardCard title="Schools with Highest Enrollments">
                <Box sx={{ p: 2 }}>
                    <Alert severity="error" sx={{ m: 2 }}>
                        {error}
                    </Alert>
                </Box>
            </DashboardCard>
        );
    }

    return (
        <DashboardCard title="Schools with Highest Enrollments" onExport={handleExport}>
            <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <SchoolEnrollmentFilterControls />
                <DashboardChartViewSelect dashboard="schoolEnrollment" value={chartView} onChange={setChartView} />
                
                <Box sx={{ flexGrow: 1, minHeight: 0 }}>
                     <SchoolEnrollmentChart 
                        data={data} 
                        chartRef={chartRef} 
                        filter={filter}
                        isExpanded={isExpanded}
                        chartView={chartView}
                    />
                </Box>
            </Box>
        </DashboardCard>
    );
};

export const SchoolEnrollmentCard = () => {
    return (
        <SchoolEnrollmentDataProvider>
            <SchoolEnrollmentCardContent />
        </SchoolEnrollmentDataProvider>
    );
};
